import ClaimOrdersTable from "./ClaimOrdersTable";

export default ClaimOrdersTable;
